import { ModuleConfig } from '@/core/module';
import { dayEndRoutes } from './routes';

export const DayEndModule: ModuleConfig = {
    name: 'day-end',
    routes: dayEndRoutes,
    stores: {},
    initialize: () => {
        console.log('Day-End module initialized');
    },
};

export default DayEndModule;
